removeWorker